var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "Search_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "m19.65 20.97-5.94-5.94a5.746 5.746 0 0 1-3.583 1.226q-2.568 0-4.347-1.779Q4 12.697 4 10.128T5.78 5.78 10.128 4t4.349 1.78 1.78 4.348a5.75 5.75 0 0 1-1.226 3.583l5.94 5.94zm-9.522-6.6q1.768 0 3.005-1.236 1.238-1.237 1.238-3.006 0-1.767-1.238-3.005-1.236-1.237-3.005-1.237-1.767 0-3.005 1.237t-1.237 3.005 1.237 3.005q1.238 1.238 3.005 1.238"
}))));
export default SvgSearch;